export default "__VITE_ASSET__BV9Q2cgE__"